import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const UserCircle = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 7C13.7 7 15 8.3 15 10C15 11.7 13.7 13 12 13C10.3 13 9 11.7 9 10C9 8.3 10.3 7 12 7ZM12 20C9.8 20 7.7 19.1 6.2 17.5C8.4 14.3 12.7 13.5 15.9 15.7C16.6 16.2 17.2 16.8 17.7 17.5C16.3 19.1 14.2 20 12 20Z"
      fill="currentColor"
    />
  </svg>
)

export default UserCircle
